
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.9 3.272a1.917 1.917 0 00-1.917 1.917.75.75 0 01-.75.75H3.567a.317.317 0 00-.317.316v11.2a.317.317 0 00.317.317H8.9a.75.75 0 010 1.5H3.567a1.817 1.817 0 01-1.817-1.817v-11.2A1.817 1.817 0 013.567 4.44h2a3.417 3.417 0 016.666 0h2a1.817 1.817 0 011.817 1.816v1.6a.75.75 0 01-1.5 0v-1.6a.317.317 0 00-.317-.316h-2.666a.75.75 0 01-.75-.75A1.917 1.917 0 008.9 3.272zM5.7 8.705a.75.75 0 100 1.5h3.734a.75.75 0 000-1.5H5.7zm4.986 2.003a5.017 5.017 0 117.095 7.095 5.017 5.017 0 01-7.095-7.095zm3.547.03a3.517 3.517 0 100 7.034 3.517 3.517 0 000-7.033zm0 .634a.75.75 0 01.75.75v2.456l.32-.32a.75.75 0 111.06 1.061l-1.597 1.598a.756.756 0 01-.79.176.747.747 0 01-.273-.174l-1.6-1.6a.75.75 0 011.06-1.06l.32.32v-2.457a.75.75 0 01.75-.75zm-9.283.75a.75.75 0 01.75-.75h2.134a.75.75 0 010 1.5H5.7a.75.75 0 01-.75-.75zm.75 1.917a.75.75 0 000 1.5h2.134a.75.75 0 000-1.5H5.7zm2.481-9.836A1.017 1.017 0 119.62 5.641 1.017 1.017 0 018.18 4.203z"}})])
          )
        }
      }
    